import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import logo from "../../images/sas.webp";

const FormPageHeader = ({ onLoginClick }) => {
  return (
    <>
      <button
        className="absolute top-0 right-0"
        onClick={onLoginClick}
        aria-label="Go to login"
        title="Go to login"
      >
        <FontAwesomeIcon
          icon={faRightToBracket}
          className="text-sas-primary text-2xl mr-2 mt-2 hover:text-blue-700"
        />
      </button>

      <div className="flex items-center">
        <div className="text-xl md:text-4xl font-bold md:mb-8 bg-sas-primary py-10 w-3/4 rounded-r-full">
          <h1 className="pl-6 md:pl-16 text-white font-fatfrank">
            Health Screening Report
          </h1>
        </div>
        <div className="mb-5">
          <img
            src={logo}
            alt="schools advisory service logo"
            className="overflow-hidden w-64"
          />
        </div>
      </div>
    </>
  );
};

export default FormPageHeader;
